import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
// Detect whether it's running in React Native
const isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    // fallbackLng: "en",
    backend: {
      loadPath: "/locales/{{lng}}.json",
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: !isReactNative,
    },
    defaultNS: "common",
    ns: [],
  });

export default i18n;
